import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const Wrapper = styled.div`
  padding: 12px;
  height: 100%;
  overflow-y: auto;
  overflow-x: visible;
  position: relative;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 3px;
  }

  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.15) transparent;
`;

export const SkeletonWrapper = styled.div`
  padding: 16px;

  .MuiSkeleton-root {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }
`;

export const GlobalModulesSection = styled.div`
  margin-bottom: 16px;
`;

export const GlobalModuleItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin: 2px 0;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.04);
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.08) 20%,
    rgba(255, 255, 255, 0.08) 80%,
    transparent
  );
  margin: 16px 0;
`;

export const LanguagesSection = styled.div`
  margin-top: 8px;
`;

export const LanguageGroup = styled.div`
  margin-bottom: 20px;
`;

export const LanguageHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  margin-bottom: 4px;
  user-select: none;
  cursor: pointer;
`;

export const LanguageTitle = styled.span`
  flex: 1;
  font-size: 11px;
  color: #8b92a8;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;

export const CollapseIcon = styled.span<{ $collapsed?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 6px;
  color: #8b92a8;
  transform: rotate(${(p) => (p.$collapsed ? '0deg' : '90deg')});
  transition: transform 0.15s ease-in-out, color 0.15s ease-in-out;
`;

export const FlagWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  border-radius: 2px;
  overflow: hidden;
  opacity: 0.8;
`;

export const CourseList = styled.div`
  margin: 0 0 0 6px;
  padding-left: 12px;
  position: relative;
`;

export const CourseItemWrapper = styled.div`
  position: relative;
  z-index: 1;

  &:hover {
    z-index: 10;
  }
`;

export const CourseItem = styled.div<{ hasModules?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  margin: 1px 0;
  border-radius: 6px;
  cursor: pointer;
  position: relative;

  &:hover {
    background: rgba(255, 255, 255, 0.04);
  }
`;

export const CourseTitle = styled.span`
  font-size: 15px;
  color: #c8cdd8;
  font-weight: 400;
  letter-spacing: 0.2px;
  flex: 1;

  ${CourseItem}:hover & {
    color: #fff;
  }
`;

export const ModuleCount = styled.span`
  font-size: 12px;
  color: #6b7280;
  background: rgba(255, 255, 255, 0.08);
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: 8px;
  font-weight: 500;
`;

export const PopperContent = styled(Paper)<{ moduleCount: number }>`
  background: #242837 !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  min-width: 200px;
  max-width: ${(props) => (props.moduleCount > 12 ? '600px' : '300px')};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
  overflow: hidden;

  ${(props) =>
    props.moduleCount > 24 &&
    `
    max-width: 900px;
  `}
`;

export const DropdownHeader = styled.div`
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 4px;
`;

export const DropdownTopRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

export const DropdownFlag = styled.div`
  display: flex;
  align-items: center;
  margin-right: 6px;
`;

export const DropdownLanguage = styled.div`
  font-size: 11px;
  color: #8b92a8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const DropdownCourseName = styled.div`
  font-size: 15px;
  color: #fff;
  font-weight: 500;
`;

export const ModulesGrid = styled.div<{ moduleCount: number }>`
  padding: 8px;

  ${(props) =>
    props.moduleCount > 12 &&
    `
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px 16px;
    grid-auto-flow: column;
    grid-template-rows: repeat(${Math.ceil(props.moduleCount / 2)}, auto);
  `}

  ${(props) =>
    props.moduleCount > 24 &&
    `
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(${Math.ceil(props.moduleCount / 3)}, auto);
  `}
`;

export const ModuleItem = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;

export const ModuleIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-right: 10px;
  color: #8b92a8;

  svg {
    font-size: 14px;
  }

  ${ModuleItem}:hover & {
    color: #c8cdd8;
  }
`;

export const ModuleName = styled.span`
  color: #c8cdd8;
  flex: 1;

  ${ModuleItem}:hover & {
    color: #fff;
  }
`;

export const ModuleIcon = styled.div`
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;

  svg {
    font-size: 15px;
    color: #8b92a8;
  }

  ${GlobalModuleItem}:hover & svg {
    color: #c8cdd8;
  }
`;

export const ModuleTitle = styled.span`
  font-size: 15px;
  color: #d4d8e4;
  font-weight: 500;
  letter-spacing: 0.3px;

  ${GlobalModuleItem}:hover & {
    color: #fff;
  }
`;
